/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * FormInput.tsx
 */

import HiloReactComponent from "../../layout/HiloReactComponent";
import React from "react";
import {IonIcon} from "../IonIcon";
import {ButtonProps} from "./ButtonProps";

export default class Button extends HiloReactComponent<ButtonProps, {}> {
    /**
     * render
     * @returns {any}
     */
    public render() {
        const {labelAccessor, outline, key, disabled, icon, color, loading, fullwidth, onClick} = this.props;

        return <button
            className={`btn ${loading && "is-loading"} ${fullwidth && "is-fullwidth"} ${outline && "is-outlined"}`}
            style={{
                border: `1px solid ${color.bg}`,
                backgroundColor: outline ? color.fg : color.bg,
                color: outline ? color.bg : color.fg
            }}
            disabled={disabled}
            onClick={() => {
                onClick?.(key)
            }}>
            {!!icon && <span className="icon"><IonIcon name={icon} color={color.fg}/></span>}
            {!!labelAccessor && <span>{loading ? this.t.loading : labelAccessor(this.t)}</span>}
        </button>;
    }
}